import { render, staticRenderFns } from "./HeaderMerchants.vue?vue&type=template&id=78101ce6&scoped=true&"
import script from "./HeaderMerchants.vue?vue&type=script&lang=js&"
export * from "./HeaderMerchants.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMerchants.vue?vue&type=style&index=0&id=78101ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78101ce6",
  null
  
)

export default component.exports